import searchSlugUtils from 'app/shared/utils/searchSlugUtils';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('utils/seo');

interface SearchSlugConfig {
  filter: {
    listingTypes: Array<string>;
    propertyTypes: Array<string>;
    orderBy?: string;
  };
  excludeAreaTypes: Array<string>;
  seoApiKeyword: string;
}

type ActiveSearchSlugs = Record<string, SearchSlugConfig>;

const seoUtils = {
  getConsolidatedUri(uri = ''): string {
    let pathname: string;

    try {
      const url = new URL(uri);
      pathname = url.pathname;
    } catch (err) {
      pathname = uri;
    }

    const searchSlug = searchSlugUtils.getSearchSlugFromUrl(pathname);

    if (!searchSlug) {
      return uri;
    }

    return uri;
  },
  translateSlugToApiKeyword(searchSlug: string): string | false {
    const activeSlugs: ActiveSearchSlugs = searchSlugUtils.active();

    if (activeSlugs[searchSlug]) {
      return activeSlugs[searchSlug].seoApiKeyword;
    } else {
      logger?.warn('seoUtils#translateSlugToApiKeyword unhandled search slug', searchSlug);
      return false;
    }
  },
};

export default seoUtils;
